const routes = [
  {
    path: '/notification_settings',
    name: 'notification-settings',
    component: () => import(/* webpackChunkName: "NotificationSettings" */ './views/NotificationSettings.vue'),
    props: { featureFlag: 'rollout.migration.pov_notifications', angularRoute: 'app.notification_settings' },
    meta: { i18n: 'notifications-pov', pageNameEn: 'Notification Settings' },
  },
];

export default routes;
